import { HStack, Box } from '@cdl/heartbeat-react';
import { forwardRef } from 'react';
import { ResetButton } from '../basic/ResetButton';

interface Props {
  ecgId: string;
}

export const NavbarActions = forwardRef<HTMLDivElement, Props>(
  ({ ecgId }, ref) => {
    return (
      <HStack spacing='xxs'>
        <Box ref={ref} />
        <ResetButton ecgId={ecgId} />
      </HStack>
    );
  },
);
